import React from 'react'
import Header from '../Header'
import Parser from 'html-react-parser';

import './RoundedPhoto.css'

const roundedPhoto = props => {
  var roundedPhotoElements = []
  var rowPhotoElements = []
  //console.log(props)
  for (let itemIndex = 0; itemIndex < props.items.length; itemIndex++) {
    if (props.items[itemIndex].image) {
      let text = props.items[itemIndex].text;
      let normalizedText = replaceAll(text,"[.]", "<br>");
      //console.log("Item text is: "+text);
      //console.log("Item normalized text is: "+normalizedText);
      let caption = (
        <div className="roundedPhoto_content">
          <h4 className="roundedPhoto_title">
            {props.items[itemIndex].title}
          </h4>
          <div className="roundedPhoto_subtitle">
            {props.items[itemIndex].subtitle}
          </div>
          <div className="roundedPhoto_text">{Parser(normalizedText)}</div>
        </div>
      )

      let img = (
          <img src={props.items[itemIndex].image} alt={`Service ${normalizedText}`}/>
      )

      if (itemIndex % 2 === 1) {
        rowPhotoElements.push(<div className="roundedPhoto_cell right">
            {img}
            {caption}
        </div>)
      } else {
        rowPhotoElements.push(
          <div className="roundedPhoto_cell left">
            {caption}
            {img}
          </div>
        )
      }
    }

    /* If is even is left. If is odd is right */

    /* If its the second photo or the last one, close the row and reset the array */
    if (itemIndex % 2 === 1 || itemIndex === props.items.length - 1) {
      roundedPhotoElements.push(
        <div className="roundedPhoto_row">{rowPhotoElements}</div>
      )
      rowPhotoElements = []
    }
  }

  return (
    <div>
      <div className="roundedPhoto_container">
        <Header headerProps={props.headerProps} />
      </div>
      {roundedPhotoElements}
    </div>
  )
}


function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, 'g'), replace);
}

export default roundedPhoto
